<script>
/** Mixin PDCA color config */
export default {
  data() {
    return {
      doughnutBgColor: '#EAEAEA',
      doughnutFgGray: '#888888',
      doughnutBgRed: '#FFBABA',
      doughnutBgGood: ['#BABAFF', '#BAFFBA'],
      indicatorInputEditOverrun: '#912a2a',
      indicatorInputOverrun: '#f9cbcb',
    };
  },
  computed: {
    companyDoughnutBgColor() {
      return this.doughnutBgGood[this.currentTeam.chartColor || 0];
    },
  },
};
</script>
